import { useContext, useEffect, useState } from "react";
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";
import { getCustomisationFieldData, getCustomisationValue, getGroupData } from "../../../EditablePreview/EditablePreview";
import ModuleTextInput from "../../components/ModuleTextInput";
import FeatureIcon from '../../../../WorkspaceAssets/ListIcons/feature-icon.png';
import { slideOutPanelControl } from "../../../../../../../containers/TimelineEditor/slideout-panel/SlideoutPanel";
import { changeValue_noType } from "../../ModuleList";
import { findFeatureData } from "../../../../v2IntegrationHelpers/CampaignAndFeatureDataHelperFunctions";
import NumberField from "../numberField/NumberField";
import ModuleNumericalInput from "../../components/ModuleNumericalInput";

const DisruptorField = (props) => {
    console.log("Rendering DisruptorField with props:", props);
    const fieldData = props.fieldData;
    const moduleConfig = props.moduleConfig;
    const groupConfig = props.groupConfig;
    const customisationVars = props.customisationVars;

    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    const rawDisruptorData = getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink ?? fieldData?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null;
    const [disruptorData, setDisruptorData] = useState(rawDisruptorData?.split?.(':')?.[0] ?? rawDisruptorData);
    const [disruptorParamData, setDisruptorParamData] = useState(rawDisruptorData?.split?.(':')?.[1] ?? null);

    useEffect(() => {
        setDisruptorData(rawDisruptorData?.split?.(':')?.[0] ?? rawDisruptorData);
        setDisruptorParamData(rawDisruptorData?.split?.(':')?.[1] ?? null);
    }, [rawDisruptorData]);

    // Find out if our current disruptor has any trigger command data we need to implement
    const CommandParamField = (props) => {
        const featureId = rawDisruptorData?.split?.(':')?.[0];
        if (!featureId) {
            return null;
        }
        const featureData = findFeatureData(campaignContext?.campaignData, featureId);
        if (featureData) {
            let triggerCommandData = null;
            for (let i = 0; i < featureData.feature.commands.length; i++) {
                if (featureData.feature.commands[i].isPrimaryTrigger) {
                    triggerCommandData = featureData.feature.commands[i];
                    break;
                }
            }
            console.log("DisruptorField: Found triggerCommandData for disruptor:", triggerCommandData);
            if (triggerCommandData && triggerCommandData.triggerParam) {
                const paramVal = disruptorParamData || triggerCommandData.triggerParam.default;
                const chosenDisruptorCustomisationVars = props.getCustomisationVarsForFeature ? props.getCustomisationVarsForFeature(featureId) : customisationVars;

                const paramDropdownOptions = [];
                // If we have a dropdown type, we need to build the options array for it
                for (let i = 0; i < triggerCommandData.triggerParam.options.length; i++) {
                    const optionVal = triggerCommandData.triggerParam.options[i];
                    console.log("DisruptorField: Processing trigger param option:", optionVal);
                    if (optionVal?.label && optionVal?.value !== undefined) {
                        paramDropdownOptions.push({ label: optionVal.label, value: optionVal.value, subNote: optionVal.subNote });
                    } else {
                        if (optionVal.listPath) {
                            const listData = getGroupData(chosenDisruptorCustomisationVars, optionVal.listPath, -1, true);
                            console.log("DisruptorField: Retrieved list data for dropdown options:", listData, optionVal.listPath);
                            if (listData?.length > 0) {
                                for (let j = 0; j < listData.length; j++) {
                                    const listItem = listData[j];
                                    let optionLabel = "";
                                    if (optionVal.labelPrefix) {
                                        optionLabel += optionVal.labelPrefix;
                                    }
                                    if (optionVal.labelKey) {
                                        optionLabel += listItem[optionVal.labelKey] ?? '';
                                    }
                                    if (optionVal.labelSuffix) {
                                        optionLabel += optionVal.labelSuffix;
                                    }
                                    if (optionLabel === '') {
                                        optionLabel = listItem?.name ?? listItem?.id ?? listItem?.value ?? listItem?.val ?? `Option ${j + 1}`;
                                    }
                                    let optionValue = null;
                                    if (optionVal.valueKey) {
                                        if (optionVal.valueKey === 'index') {
                                            optionValue = j;
                                        } else if (optionVal.valueKey === 'id' && listItem._id) {
                                            optionValue = listItem._id;
                                        } else {
                                            optionValue = listItem[optionVal.valueKey];
                                        }
                                    } else {
                                        optionValue = listItem?.id ?? listItem?.value ?? listItem?.val ?? optionLabel;
                                    }
                                    if (optionValue === null) {
                                        optionValue = j; // Fallback to index if we can't find a value
                                    }
                                    if (optionVal.valuePrefix) {
                                        optionValue = `${optionVal.valuePrefix}${optionValue}`;
                                    }
                                    if (optionVal.valueSuffix) {
                                        optionValue = `${optionValue}${optionVal.valueSuffix}`;
                                    }
                                    paramDropdownOptions.push({ label: optionLabel, value: optionValue, subNote: optionVal.subNote });
                                }
                            }
                        }
                    }
                }
                const getParamDisplayValue = (value) => {
                    for (let i = 0; i < paramDropdownOptions.length; i++) {
                        if (paramDropdownOptions[i].value == value || paramDropdownOptions[i].val == value) {
                            return paramDropdownOptions[i].label;
                        }
                    }
                    return paramDropdownOptions?.[0]?.label ?? value;
                }
                const getSubNoteForValue = (value) => {
                    for (let i = 0; i < paramDropdownOptions.length; i++) {
                        if (paramDropdownOptions[i].value == value || paramDropdownOptions[i].val == value) {
                            return paramDropdownOptions[i].subNote;
                        }
                    }
                    return null;
                }
                console.log("DisruptorField: Built paramDropdownOptions:", paramDropdownOptions, "with current paramVal:", paramVal, "and display value:", getParamDisplayValue(paramVal));

                /*return (
                    <div className='fl-row list-view-content'>
                        {getControl(triggerCommandData.triggerParam, paramVal, valsArray, index, valKey, true, (val) => {updateTriggerParam(val, varSchema, varVal, valsArray, index, valKey)})}
                    </div>
                )*/
               return (
                    <div className="v2-module-one-column v2-full-width" style={{marginTop: -6}}>
                        <div className={`v2-module-field-label${!props.isEnabled ? ' disabled' : ''}`}>{triggerCommandData?.triggerParam?.label ?? 'Trigger Param'}</div>
                        {triggerCommandData?.triggerParam?.type === 'number' && /* This will need expanding on later, but for now only Sub Bomb uses this and it needs number param, so... */
                            <ModuleNumericalInput
                                value={Number(paramVal)}
                                fieldId={'disruptor-trigger-param'}
                                enabled={props.isEnabled}
                                editable={true}
                                onChange={(fieldId, value) => {
                                    const newDisruptorData = `${disruptorData}:${value}`;
                                    console.log("DisruptorField: Changing disruptor param value:", value, "New disruptor data:", newDisruptorData);
                                    changeValue_noType(
                                        customisationVars,
                                        fieldData?.customFieldConfig ?? fieldData,
                                        newDisruptorData,
                                        props.index ?? 0,
                                        props.visualisationComponentKey ?? null,
                                        props.selectedFeatureNode,
                                        true,
                                        false
                                    );
                                    setDisruptorParamData(value);
                                }}
                            /> 
                        }
                        {/* Currently disabled, Image Disruptor seeder is set up for this, but the disruptor isn't */}
                        {triggerCommandData?.triggerParam?.type === 'dropdown' &&
                            <>
                                <ModuleTextInput
                                    value={getParamDisplayValue(paramVal)}
                                    fieldId={'disruptor-trigger-param'}
                                    enabled={props.isEnabled}
                                    editable={false}
                                    onChange={(fieldId, value) => {
                                        const newDisruptorData = `${disruptorData}:${value}`;
                                        console.log("DisruptorField: Changing disruptor param value:", value, "New disruptor data:", newDisruptorData);
                                        changeValue_noType(
                                            customisationVars,
                                            fieldData?.customFieldConfig ?? fieldData,
                                            newDisruptorData,
                                            props.index ?? 0,
                                            props.visualisationComponentKey ?? null,
                                            props.selectedFeatureNode,
                                            true,
                                            false
                                        );
                                        setDisruptorParamData(value);
                                    }}
                                    hiddenDropDown={true}
                                    hiddenDropDownOptions={paramDropdownOptions}
                                    dropDownValue={paramVal ?? paramDropdownOptions[0]?.value ?? null}
                                />
                                {getSubNoteForValue(paramVal) && <div className={`v2-module-field-label${!props.isEnabled ? ' disabled' : ''}`}>{getSubNoteForValue(paramVal)}</div> }
                            </>
                        }
                    </div>
               );
            }
        }
        console.log("DisruptorField: No triggerCommandData found for disruptor with featureId:", featureId);
        return null;
    }
    // CommandParamField();

    const disruptorClickHandler = (forceDisruptorId = null) => {
        // console.log("DISRUPTOR FIELD CLICK HANDLER");
        // props.openClassicCustomisationSubsetPopup(fieldData?.customFieldConfig?.dataLink, props.index ?? 0, 'Select Disruptor', props.forceModuleListUpdate);
        const selectedDisruptorId = forceDisruptorId ?? disruptorData;
        slideOutPanelControl.openDisruptorSelector(
            typeof selectedDisruptorId === 'string' && selectedDisruptorId ? selectedDisruptorId?.split?.(':')?.[0] ?? selectedDisruptorId : null,
            (selectedDisruptor) => {
                console.log('DisruptorField: Disruptor changed callback', selectedDisruptor);
            },
            (selectedDisruptor) => {
                console.log('DisruptorField: Disruptor selected confirmed', selectedDisruptor);
                // if (selectedDisruptor) {
                    const updatedDisruptorData = selectedDisruptor && selectedDisruptor.length ? `${selectedDisruptor}${disruptorParamData ? `:${disruptorParamData}` : ''}` : '';
                    changeValue_noType(
                        customisationVars,
                        fieldData?.customFieldConfig ?? fieldData,
                        updatedDisruptorData,
                        props.index ?? 0,
                        props.visualisationComponentKey ?? null,
                        props.selectedFeatureNode,
                        true,
                        false
                    );
                    setDisruptorData(selectedDisruptor);
                    // Refresh the slide out panel
                    disruptorClickHandler(selectedDisruptor);
                // }
            },
            'Select Disruptor',
            fieldData?.customFieldConfig ?? fieldData,
            getCustomisationFieldData(campaignContext?.campaignData, props.selectedFeatureNode.id, fieldData?.customFieldConfig?.dataLink ?? fieldData?.dataLink)
        );
    }

    // console.log("DISRUPTOR FIELD RENDER", disruptorData, props);

    const getDisruptorName = (disruptorId) => {
        const disruptorFeature = campaignContext?.campaignData?.features?.find(feature => feature._id === disruptorId);
        return disruptorFeature ? disruptorFeature?.contentLabel || disruptorFeature.feature.featureName : '<Unknown Disruptor>';
    }

    return (
        <>
            <div className={`v2-module-field-label${!props.isEnabled ? ' disabled' : ''}`}>{fieldData?.customFieldConfig?.customFieldLabel ?? fieldData?.customFieldLabel ?? 'Select Disruptor'}</div>
            <ModuleTextInput
                fieldLabel={<div className="v2-module-block-field-input-label" style={{backgroundColor: '#FFFFFF', backgroundImage: `url(${FeatureIcon})`, backgroundSize: '1.8rem', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}} />}
                value={typeof disruptorData === 'string' && disruptorData ? getDisruptorName(disruptorData) : '<No Disruptor Selected>'}
                fieldId={'select-disruptor'}
                enabled={props.isEnabled}
                editable={false}
                onChange={null}
                onClick={
                    props.isEnabled ? () => disruptorClickHandler(disruptorData) : null
                }
            />
            <CommandParamField {...props} isEnabled={props.isEnabled} />
        </>
    );
}

export default DisruptorField;
